import { ColorizeSharp } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import styled from '@mui/system/styled';
import CTypography from 'components/CTypography';
import { colors } from 'components/theme/constants';

export const QuickTasksCnt = styled('div')(({ theme }) => ({
  display: 'flex',
  '& .create-tasks': {
    width: 486,
    height: 600,
    background: colors.white,
    padding: '50px 40px 20px 40px',
    position: 'relative',
    borderRadius: 30,
    '& .addOption': {
      display: 'flex',
      alignItems: 'center',
      marginBottom: 30,
      '& .iconCnt': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 26.67,
        width: 26.67,
        backgroundColor: '#6868FE',
        borderRadius: '50%',
        marginRight: 10,
      },
      '& .title': {
        fontWeight: 700,
        fontSize: 24,
        lineHeight: '157%',
        letterSpacing: '0.1px',
        color: '#6868FE',
      },
    },

    '& .footerCnt': {
      position: 'absolute',
      bottom: 20,
      width: 'calc(100% - 80px)',
      '& .innerCnt': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      },
    },
  },

  '& .show-tasks': {
    width: 782,
    height: 600,
    background: '#EBEAFF',
    padding: '100px 0px 100px 70px',
    borderTopRightRadius: 28,
    borderBottomRightRadius: 30,
    '& .content': {
      background: colors.white,
      boxShadow: '0px 5px 22px 4px rgba(104, 104, 254, 0.2)',
      borderRadius: '8px 0px 0px 8px',
      height: 392,
      padding: 20,
      '& .MuiTableCell-head': {
        padding: '10px 16px',
      },
      '& .colHead': {
        fontWeight: 400,
        fontSize: 13,
        lineHeight: '20.8px',
        letterSpacing: '0.15px',
        color: '#424242',
      },
      '& .title': {
        fontWeight: 800,
        fontSize: 20,
        lineHeight: '160%',
        letterSpacing: '0.15px',
        color: 'rgba(0, 0, 0, 0.87)',
        marginBottom: 20,
      },
    },
  },
}));

export const OpenStatus = styled('div')(({ theme }) => ({
  background: '#0288D1',
  borderRadius: 16,
  padding: '4px 13px',
  '& p': {
    color: colors.white,
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '166%',
    letterSpacing: 0.4,
  },
}));

export const LocationCnt = styled('div')(({ theme }) => ({
  border: '1px solid rgba(0, 0, 0, 0.23)',
  borderRadius: 6,
  padding: '6px 0px',
  '& p': {
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '16px',
    letterSpacing: '0.17px',
    color: '#757575',
  },
}));

export const CategoryCnt = styled('div', {
  shouldForwardProp: (prop) => prop !== 'bg' && prop !== 'color',
})(({ bg, color }) => ({
  borderRadius: 6,
  padding: '6px 0px',
  backgroundColor: bg,
  '& p': {
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '19.92px',
    letterSpacing: '0.4px',
    color: color,
  },
}));

export const AssigneeCnt = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  '& .innerCnt': {
    border: '1px dashed #BDBDBD',
    borderRadius: 10,
    width: 32,
    height: 32,
    padding: 5,
  },
}));

export const NameCell = styled(CTypography)(({ theme }) => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: 165,
  fontWeight: 500,
  fontSize: 14,
  lineHeight: '22.4px',
  letterSpacing: '0.15px',
  color: '#616161',
}));

export const CrossIconBtn = styled(IconButton)(({ theme }) => ({
  cursor: 'pointer',
  '& svg': {
    width: 15,
    height: 15,
    '& path': {
      stroke: '#0000008A',
    },
  },
}));
